import { useConnect } from 'redux-bundler-hook'

import { FileDownload } from '@mui/icons-material'
import { Button } from '@mui/material'

import { downloadFile, useSmallScreen } from '@common/utils'
import { formatCSVData } from '@rest/Utils/csv'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.entity
 * @param {Object} props.entity.name
 */
export default function ExportEventsButton({ entity }) {
  const isSmallScreen = useSmallScreen()

  const { eventListIsLoading, doEventListExport } = useConnect(
    'selectEventListIsLoading',
    'doEventListExport',
  )

  return (
    <Button
      fullWidth={isSmallScreen.mobile}
      data-testid="export_events"
      variant="contained"
      disabled={eventListIsLoading}
      sx={{ ml: 1 }}
      onClick={async () => {
        const result = await doEventListExport()
        const data = formatCSVData(result, (event) => ({
          unitName: 'Unit Name',
          zoneName: 'Zone Name',
          eventClass: 'Type',
          createdOn: 'Created On',
          endTime: 'End Time',
          lastOccurrence: 'Last Occurrence',
          billable: 'Billable',
          [`${
            event.eventClass === 'NOISE' ? 'noiseFeedback' : 'smokeFeedback'
          }.comments`]: 'Comments',
          [`${
            event.eventClass === 'NOISE' ? 'noiseFeedback' : 'smokeFeedback'
          }.modifiedByName`]: 'Modified By',
          [`${
            event.eventClass === 'NOISE' ? 'noiseFeedback' : 'smokeFeedback'
          }.modifiedOn`]: 'Modified On',
          'smokeFeedback.adjustmentReason': 'Adjustment Reason',
          'smokeFeedback.adjustedOn': 'Adjusted On',
          'smokeFeedback.netChargeAmount': 'Net Charge Amount',
          'reservation.confirmationNumber': 'Confirmation Number',
        }))
        downloadFile({
          data: [data],
          fileName: `${entity.name}_events_export.csv`,
          fileType: 'text/csv',
        })
      }}
      startIcon={!isSmallScreen.mobile ? <FileDownload /> : null}
    >
      Export
    </Button>
  )
}
